import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative flex items-center justify-center p-0 md:p-5 group" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src", "alt", "title"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "absolute bottom-0 left-0 w-full h-1/4 lg:h-1/5 rounded-b-xl bg-gray-900/85 text-white p-2 lg:p-3 opacity-100 group-hover:opacity-100 duration-300" }
const _hoisted_6 = { class: "text-sm lg:text-base text-left font-bold w-full h-full text-wrap line-clamp-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton_on = _resolveComponent("skeleton-on")!
  const _component_button_on = _resolveComponent("button-on")!
  const _component_card_on = _resolveComponent("card-on")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.isPosterLoaded && !_ctx.isNotFoundImageLoaded)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass([{'hidden': _ctx.isPosterLoaded}, "relative w-full rounded-xl aspect-[2/3]"])
        }, [
          _createVNode(_component_skeleton_on, {
            shape: "rectangle",
            width: "100%",
            height: "100%",
            borderRadius: "12px",
            class: "bg-gray-700/25"
          })
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_card_on, {
      onClick: _ctx.navigateToDetail,
      class: "relative rounded-xl hover:opacity-50 hover:bg-[#8888a0] hover:p-2 ease-in-out duration-300 md:cursor-pointer h-full",
      unstyled: ""
    }, {
      header: _withCtx(() => [
        (_ctx.isPosterLoaded && _ctx.isFavoritePage)
          ? (_openBlock(), _createBlock(_component_button_on, {
              key: 0,
              icon: "pi pi-times",
              "aria-label": "Fechar",
              class: _normalizeClass([
                        'absolute -top-2 -right-2 p-button-text p-button-rounded text-white bg-red-600 transition-all duration-300 scale-75 hover:bg-red-900 hover:p-4 ease-in-out border-2 border-white z-10',
                        _ctx.isClicked ? 'scale-125' : 'scale-90',
                        'sm:opacity-100 lg:opacity-0 group-hover:opacity-100'
                    ]),
              onClick: _withModifiers(_ctx.handleButtonClick, ["stop","prevent"])
            }, null, 8, ["class", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      content: _withCtx(() => [
        _createElementVNode("section", null, [
          (_ctx.movie.poster_path)
            ? (_openBlock(), _createElementBlock("figure", _hoisted_2, [
                _createElementVNode("img", {
                  src: _ctx.posterImage,
                  alt: _ctx.movie.original_title,
                  title: _ctx.movie.original_title,
                  class: "relative w-full h-full rounded-xl",
                  onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePosterLoad && _ctx.handlePosterLoad(...args)))
                }, null, 40, _hoisted_3)
              ]))
            : (_openBlock(), _createElementBlock("figure", {
                key: 1,
                class: _normalizeClass({ 'hidden': !_ctx.isNotFoundImageLoaded })
              }, [
                _createElementVNode("img", {
                  src: _ctx.notFoundImage,
                  alt: "Imagem não encontrada",
                  title: "Imagem não encontrada",
                  class: "relative w-full h-full rounded-xl",
                  onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNotFoundImageLoad && _ctx.onNotFoundImageLoad(...args)))
                }, null, 40, _hoisted_4)
              ], 2))
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("section", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.movie.original_title), 1)
        ])
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}